import React, { useState } from "react";
import {
  Grid,
  CircularProgress,
  TextField as Input
} from "@material-ui/core";
import { withRouter, useHistory } from "react-router-dom";

// styles
import useStyles from "./styles";

// context
import { useUserDispatch, resetPassword } from "../../context/UserContext";

//components
import { Button, Typography } from "../../components/Wrappers";

function Reset() {
  var classes = useStyles();
  const history = useHistory();
  // global
  var userDispatch = useUserDispatch();
  const [passwordValue, setPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const validatePassword = () => {
    const minLength = 6;
    
    if (passwordValue !== confirmPasswordValue) {
      return { valid: false, message: "Lösenorden matchar inte" }
    }

    if (passwordValue.length < minLength) {
        return { valid: false, message: `Lösenordet måste vara minst ${minLength} tecken långt.` };
    }

    if (!/[A-Z]/.test(passwordValue)) {
        return { valid: false, message: "Lösenordet måste innehålla minst en versal (A-Z)." };
    }

    if (!/[a-z]/.test(passwordValue)) {
        return { valid: false, message: "Lösenordet måste innehålla minst en gemen (a-z)." };
    }

    if (!/\d/.test(passwordValue)) {
        return { valid: false, message: "Lösenordet måste innehålla minst en siffra (0-9)." };
    }

    return { valid: true, message: "" };
  }

  const doReset = () => {
    const params = new URLSearchParams(history.location.search);
    const token = params.get('token');
    const id = params.get('id');

    console.log({ id, token });
    if (!token || !id) {
      setMessage("Ogiltig länk");
    }

    const result = validatePassword();

    if(!result.valid) {
      setMessage(result.message);
    }
    else {
      resetPassword(token, id, passwordValue, setIsLoading, setMessage)(userDispatch);
    }
  }


  return (
    <Grid container className={classes.container}>
      <div className={classes.customFormContainer}>
        <div className={classes.form}>
          <Input
            id="password"
            InputProps={{
              classes: {
                underline: classes.InputUnderline,
                input: classes.Input
              }
            }}
            value={passwordValue}
            onChange={e => setPasswordValue(e.target.value)}
            margin="normal"
            placeholder="Lösenord"
            type="password"
            fullWidth
          />
          <Input
            id="confirmPassword"
            InputProps={{
              classes: {
                underline: classes.InputUnderline,
                input: classes.Input
              }
            }}
            value={confirmPasswordValue}
            onChange={e => setConfirmPasswordValue(e.target.value)}
            margin="normal"
            placeholder="Bekräfta lösenord"
            type="password"
            fullWidth
          />
          {message && (
            <Typography style={{ textAlign: 'center' }}>
              {message}
            </Typography>
          )}
          <div className={classes.formButtons}>
            {isLoading ? (
              <CircularProgress size={26} className={classes.loginLoader} />
            ) : (
              <Button
                disabled={
                  (passwordValue.length === 0 || confirmPasswordValue.length === 0) || (passwordValue !== confirmPasswordValue)
                }
                onClick={() => doReset()}
                variant="contained"
                color="primary"
                size="large"
              >
                Återställ
              </Button>
            )}
            <Button
              color="primary"
              size="large"
              onClick={() => history.push('/login')}
              className={classes.forgetButton}
            >
              Tillbaka till inloggning
            </Button>
          </div>
        </div>
        <Typography color="primary" className={classes.copyright}>
          © {new Date().getFullYear()} <a style={{ textDecoration: 'none', color: 'inherit' }}>Check Anläggningskontroll AB</a>
        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(Reset);
